// The shell's top-bar portal slot, isolated in a tiny module so the lazy editor
// chunk can render INTO the top bar (model name, sync status) by importing only
// this — not the whole AppShell (sidebar, providers). The shell owns the frame;
// the active page owns and re-renders its top-bar content (no stale snapshot).
import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export const TopBarSlotContext = createContext<HTMLElement | null>(null);

export function TopBarPortal({ children }: { children: ReactNode }) {
  const node = useContext(TopBarSlotContext);
  return node ? createPortal(children, node) : null;
}
